import { _, api, helpers, ts } from '_core';

type BacktestSetApiResponse = {
  data: ts.types.backtestSet.BacktestSet;
};

export const createBacktestSet = async (
  newData: ts.types.backtestSet.BacktestSetDraft,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BacktestSetApiResponse = await api.backtest_sets.create({
      ...newData,
      skip_signature_check: true,
    });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating backtest set - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateBacktestSet = async (
  id: number,
  newData: ts.types.backtestSet.BacktestSetDraft,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BacktestSetApiResponse = await api.backtest_sets.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating backtest set - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  backtestSet: ts.types.backtestSet.BacktestSet,
  definition: ts.types.backtestSet.DefinitionDraft,
  isValid: boolean,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.backtest_sets.update(
      backtestSet.id,
      {
        definition,
        ui_metadata: { ...backtestSet.ui_metadata },
        is_valid: isValid,
        skip_signature_check: !isValid,
      },
      true
    );

    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateUiMetadata = async (
  backtestSet: ts.types.backtestSet.BacktestSet,
  uiMetaData: ts.types.backtestSet.UiMetaData,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    if (backtestSet.shared) return;
    const updateData = {
      ui_metadata: uiMetaData,
      skip_signature_check: true,
    } as ts.types.backtestSet.BacktestSetDraft;
    const resp = await api.backtest_sets.update(backtestSet.id, updateData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the resource metadata - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const loadAnalysis = async (
  backtestSet: ts.types.backtestSet.BacktestSet,
  setAnalysis: (_data: ts.types.analysis.ResourceAnalysis) => void,
  analysisName: ts.enums.BACKTEST_SET_ANALYSIS_TYPE_ENUM,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.resource_analyses.search({
      query: [
        '$and',
        ['item_id_ref', '=', backtestSet.id],
        ['item_type', '=', ts.enums.RESOURCES_TYPES_ENUM.BACKTEST_SET],
        ['type', '=', analysisName],
      ],
    });
    const tempAnalysis = _.get(resp, 'data.0');
    setAnalysis(tempAnalysis);
  } catch (err) {
    errorCallback(`Unable to load the ${analysisName} analysis`);
  }
};
